<div></div>
<fieldset class="bordered">
  <legend>Modul MPV view</legend>
  <div class="column-100">
    <gmt-input label="Dostupnost akce" (click)="project.viewEnabled = !project.viewEnabled">
      <gmt-checkbox [gmtChecked]="project.viewEnabled" [gmtDisabled]="!project.viewMapUploadedTimestamp"></gmt-checkbox>
    </gmt-input>
    <gmt-input label="Vrstva projektové situace">
      <div class="info">
        <a (click)="onProjectUpload();" class="mr-10"><i class="fa fa-upload"></i></a>
        <span *ngIf="progress != null && progress > -1">{{progress | number:'1.0-0'}} %</span>
        <span *ngIf="progress == -1" class="color-red">Chyba při nahrávání souboru</span>
        <span *ngIf="progress == -2">Vrstva se připraví na pozadí. </span>
        <span *ngIf="(progress == null || progress == -2) && project.viewMapUploadedTimestamp">Čas nahrání dat: {{ project.viewMapUploadedTimestamp | date: 'short' }}</span>
      </div>
    </gmt-input>

    <div class="mt-10">Změny se v modulu MPV view projeví následující den</div>
  </div>
</fieldset>
